import firebase from 'firebase/app';
import "firebase/firestore";

const config = {
    apiKey: "AIzaSyDcOQ6hKert78on0108oU85CFlHxjq1oI0",
    authDomain: "veta-users-reviews.firebaseapp.com",
    projectId: "veta-users-reviews",
    storageBucket: "veta-users-reviews.appspot.com",
    messagingSenderId: "576333534859",
    appId: "1:576333534859:web:0d88570430e09468bfa68e"
};

if (!firebase.apps.length) {
    firebase.initializeApp(config);
}

const firestore = firebase.firestore();

export { firestore };